import React from 'react'
import "./experience.css"
import {AiFillCheckCircle} from "react-icons/ai"

const Experience = () => {
  return (
    <section id='experience'>
      <h5>What Skills I Have</h5>
      <h2>My Experience</h2>
      <div className="container experience_container">
        <div className="experience_frontend">
          <h3>Frontend Development</h3>
          <div className="experience_content">
            <article className="experience_details">
              <AiFillCheckCircle className="experience_details-icon" />
              <div>
              <h4>Shopify: Liquid</h4>
              <small className='text-light'>Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              <AiFillCheckCircle className="experience_details-icon" />
              <div>
              <h4>CSS3</h4>
              <small className='text-light'>Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              <AiFillCheckCircle className="experience_details-icon" />
              <div>
              <h4>Javascript</h4>
              <small className='text-light'>Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              <AiFillCheckCircle className="experience_details-icon" />
              <div>
              <h4>Taildwind<br/>CSS</h4>
              <small className='text-light'>Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              <AiFillCheckCircle className="experience_details-icon" />
              <div>
              <h4>WordPress</h4>
              <small className='text-light'>Intermediate</small>
              </div>
            </article>
            <article className="experience_details">
              <AiFillCheckCircle className="experience_details-icon" />
              <div>
              <h4>React</h4>
              <small className='text-light'>Experienced</small>
              </div>
            </article>
          </div>
        </div>
        <div className="experience_backend">
        <h3>Backend Development</h3>
          <div className="experience_content">
            <article className="experience_details">
              <AiFillCheckCircle className="experience_details-icon" />
              <div>
              <h4>MongoDB</h4>
              <small className='text-light'>Intermediate</small>
              </div>
            </article>
            <article className="experience_details">
              <AiFillCheckCircle className="experience_details-icon" />
              <div>
              <h4>MySQL</h4>
              <small className='text-light'>Intermediate</small>
              </div>
            </article>
            <article className="experience_details">
              <AiFillCheckCircle className="experience_details-icon" />
              <div>
              <h4>Node JS</h4>
              <small className='text-light'>Experienced</small>
              </div>
           
            </article>
            <article className="experience_details">
              <AiFillCheckCircle className="experience_details-icon" />
              <div>
              <h4>PHP</h4>
              <small className='text-light'>Beginner</small>
              </div>
            </article>
          </div>
          <div className="experience_content">
          
          </div>
        </div>
      </div>
    </section>
  )
}

export default Experience